import { DeploymentGroup } from '@/types/deploymentGroup'
import { Device } from '@/types/device'
import { getDeviceGpus, getDevicesCameras } from '@/utils/device/getDeviceAttr'

export const getLoadGpuName = (group: DeploymentGroup, device?: Device) => {
  const index = group.metrics?.gpu_load?.index ?? null

  if (index === null) {
    return null
  }

  const deviceGpu = device
    ? getDeviceGpus(device).find((gpu) => gpu.index === index)
    : undefined

  return deviceGpu?.name ?? (group.gpu?.index === index ? group.gpu.name : null)
}

export const getWorstCameraName = (group: DeploymentGroup, device?: Device) => {
  const worst = group.metrics?.worst_camera

  if (!worst) {
    return null
  }

  if (worst.camera_name) {
    return worst.camera_name
  }

  const member = group.members.find(
    (candidate) => candidate.deployment_id === worst.deployment_id
  )
  const camera =
    device && member
      ? getDevicesCameras(device).find(
          (candidate) => candidate.camera_id === member.stream_id
        )
      : undefined

  return camera?.camera_name ?? member?.stream_id ?? worst.deployment_id
}
